export default {
  filters: {
    recommend: '推荐',
    favorites: '收藏',
    recents: '最近',
  },
  placeholder: {
    pending: '接口待接入，敬请期待',
  },
  empty: {
    games: '暂无游戏',
    gamesHint: '换个分类看看',
    favorites: '还没有收藏',
    favoritesHint: '点游戏卡片右上角星星收藏',
    recents: '暂无最近游玩',
    recentsHint: '玩过的游戏会出现在这里',
  },
  loadMore: {
    armed: '继续上划，加载更多…',
    loading: '加载中…',
    end: '-已经到底啦-',
  },
  search: {
    searchGames: '搜游戏',
    placeholder: '搜索游戏/厂商',
    trending: '热门搜索',
    result: '找到 {count} 个结果',
    searching: '搜索中…',
    empty: '没有找到相关游戏',
    emptyHint: '换个关键词试试吧',
    clear: '清空',
    vendor: '厂商',
  },
  jackpotTicker: {
    title: '实时爆奖',
    live: 'LIVE',
    subtitle: '恭喜以下玩家喜提大奖',
    empty: '暂无爆奖信息，快来成为下一个大赢家！',
  },
  play: {
    loading: '游戏加载中...',
    transferTitle: '额度转换成功',
    copyTitle: '复制成功',
    balanceLabel: '当前「{venue}」余额',
    /** USDT 站 + CNY 映射场馆：金额下方计价提示 */
    mappedRatePrefix: '本场馆内计价',
    mappedRateEq: '1 ¥ = 1 {code}',
    mappedRateSuffix: '，进出等值可逆',
    transferDesc: '如需充值，可返回 BetCorgi 主界面，或点右上角悬浮按钮直接充值',
    copyDesc: '此处充值，可返回 BetCorgi 主界面，或点右上角悬浮按钮直接充值',
    start: '开始游戏',
    menu: {
      exit: '退出',
      deposit: '订金',
      transfer: '转移',
      support: '客服',
      expand: '展开菜单',
      collapse: '收起菜单',
    },
  },
}
